/** Shared markdown plugin config for the Moo chat library. */

/**
 * ReactMarkdown plugin configuration for chat messages.
 *
 * - remark-gfm: GFM tables, strikethrough, autolinks
 * - rehype-raw: Allow <br> in table cells
 * - rehype-sanitize: Strip dangerous HTML (scripts, iframes, event handlers)
 * - rehype-highlight: Code syntax highlighting
 */
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import rehypeHighlight from 'rehype-highlight';
import { remarkCitations } from './remark-citations';

const sanitizeSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    code: [...(defaultSchema.attributes?.code || []), 'className'],
    span: [
      ...(defaultSchema.attributes?.span || []),
      'className',
      // Preserve the citation marker so the React `span` override can swap
      // in `SourcesCitation`. `remark-citations` emits these as HTML
      // placeholders; rehype-sanitize would otherwise strip the attribute.
      'dataCitation',
    ],
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const remarkPlugins: any[] = [remarkGfm, remarkCitations];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rehypePlugins: any[] = [
  rehypeRaw,
  [rehypeSanitize, sanitizeSchema],
  rehypeHighlight,
];
